import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import FormCreateEditForm from './Components/FormCreateEditForm';
import FormApi from './FormApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: FormCreateEditForm,
                getCreate: FormApi.create,
                defaults: {fieldIds:[]},
                successMessage: "Form Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}